const optionalMenu = {
    houseViewMenu: true,
    mortgageCalculatorMenu: true,
    streetViewMenu: true,
    dynamicPagesMenu: true,
    promotionMenu: true,
}
export default optionalMenu;
